import { Component, ErrorInfo, ReactNode } from 'react';
import { trackException } from './telemetry';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

// React error boundary: catches any error thrown while rendering anywhere
// below it in the tree, reports it to App Insights via trackException, and
// shows a fallback message instead of a blank screen.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    trackException(error, {
      page: window.location.pathname,
      componentStack: info.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return <div>Something went wrong.</div>;
    }
    return this.props.children;
  }
}
